import {useSearchParams} from 'react-router'

export const useSetQueryParams = (obj = {}, watch) => {
	const [searchParams, setSearchParams] = useSearchParams()

	const setQueryParams = updates => {
		const next = new URLSearchParams(searchParams)

		Object.entries(updates).forEach(([key, value]) => {
			next.set(key, value)
		})

		setSearchParams(next, {replace: true})
	}

	return setQueryParams
}
